import _ from 'lodash';
import { combineReducers } from 'redux';

import TalentTraits from 'shared/talentTraits';

import types from 'frontend/state/actionTypes';

const TALENT_LOADOUTS_INITIAL = [];

const talentLoadouts = (state = TALENT_LOADOUTS_INITIAL, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case types.INPUT_OPTIMIZE_TEXT: {
      return _.map(payload?.character?.talentLoadouts, loadout => ({
        ...loadout,
        source: 'input',
        selected: false,
      }));
    }
    case types.CHOOSE_OPTIMIZE_TALENT_LOADOUT: {
      const { index } = payload;
      return _.map(state, loadout => {
        if (loadout.index === index) {
          return {
            ...loadout,
            selected: !loadout.selected,
          };
        }
        return loadout;
      });
    }
    case types.ADD_OPTIMIZE_TALENT_LOADOUT: {
      const { index, talentString, name, generateCombos, exclude } = payload;
      const parsed = TalentTraits.parse(talentString);
      return [
        ..._.reject(state, { index }),
        {
          index,
          name,
          rawString: talentString,
          talents: parsed,
          exclude,
          string: TalentTraits.stringify(parsed),
          generateCombos,
          source: 'user',
          selected: true,
          active: false,
        },
      ];
    }
    case types.LOAD_OPTIMIZE_REPORT:
      return payload.optimize.talentLoadouts;
    default:
      return state;
  }
};

export default combineReducers({
  talentLoadouts,
});

const fieldSelector = (field) => (state) => state.simbot.optimize.talentTrees[field];

export const selectors = {
  talentLoadouts: fieldSelector('talentLoadouts'),
};
